<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close :loading="loading" >
			<template #default>
				<vxe-grid ref="universalinvoiceinvoiceList" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return {}
				}
			},
		},
		
		data() {
			return {
				modal_title: '发票详情',
				modal_width:1000,
				modal_height:600,
				loading:false,
				list_formConfig: [{
						field: 'a',
						title: 'A',
						itemRender: {
							name: '$input'
						}
					}
				],
				list_columns: [
					{
						field: 'sflzFpbz',
						title: '类型',
						width:50,
						slots:{
							default({row}){
								return row.sflzFpbz == 'N'?<el-tag effect="dark" size="mini" type="danger">红</el-tag>:<el-tag effect="dark" size="mini" type="primary">蓝</el-tag>
							}
						},
						fixed:'left'
					},
					{
						field: 'fppzDm',
						title: '票种',
						width:50,
						slots:{
							default({row}){
								return row.fppzDm == '01'?'专票':'普票'
							}
						}
					},
					{
						field: 'xsfMc',
						title: '销售方名称',
						width:100
					},
					{
						field: 'dfNsrmc',
						title: '购方名称',
						width:120
					},
					{
						field: 'dfNsrsbh',
						title: '购方纳税人识别号',
						width:120
					},
					{
						field: 'hjje',
						title: '合计金额',
						width:100
					},
					{
						field: 'hjse',
						title: '合计税额',
						width:100
					},
					{
						field: 'jshj',
						title: '价税合计',
						width:100
					},
					{
						field: 'kprq',
						title: '开票日期',
						formatter: 'datetime',
						width:100
					},
					{
						field: 'qdFphm',
						title: '发票号码',
						width:200,
						fixed:'right'
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [row.fileUrl ? <el-link type="primary" href={row.fileUrl} target="_blank">查看</el-link>:<el-button type = "text" size = "mini" onClick = {() => {this.downloadFile(row)}}>下载</el-button>]
							}
						}
					}	
				
				],
				list_footerField:[
					{field:'hjje',toFixed:2},
					{field:'hjse',toFixed:2},
					{field:'jshj',toFixed:2},
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					this.$api.universalinvoice.getinvoicedetail({id:this.data.id}).then((res)=>{
						resolve({
							list: res
						})
					},()=>{
						resolve({
							list: []
						})
					})
				})
			},
			downloadFile(row){
				this.loading = true
				this.$api.universalinvoice.downloadFile({id:row.id}).then(()=>{
					this.loading = false
					this.$refs.universalinvoiceinvoiceList.commitProxy('query')
				},()=>{
					this.loading = false
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>